import { initLayout } from '../layout.js';
import { initPageHeader } from '../sections/page-header.js';
import NiceSelect from "nice-select2";


document.addEventListener('DOMContentLoaded', () => {
    initLayout();
    initPageHeader();
    let niceSelectOptions = document.querySelector('.nice-select-custom');
    new NiceSelect(niceSelectOptions, { searchable: false,placeholder:'Select Country' });
})
